const UserRoles = [
    { id: 'BASIC', name: 'Básico' },
    { id: 'SUPERVISOR', name: 'Supervisor' },
    { id: 'READ_ONLY', name: 'Solo lectura' }
]

export {UserRoles}
